import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory } from 'react-router-dom';
import Button from 'modules/common/input/Button';
import { storage, useQuery } from 'modules/common/helper';
import { FormInput } from 'modules/common/input';
import { isNil } from 'lodash';
import * as c from '../constants';
import { useChangePassword, useCheckToken } from '../hooks';

const INIT_FORM = {
  password: '',
  password_confirmation: '',
};

const INIT_TOKEN = {
  token: '',
};

function ChangePasswordForm() {
  const detail = storage.get('forgot-password-detail') ?? {};
  const [isApiLoading, changePassword] = useChangePassword();
  const history = useHistory();
  const query = useQuery();
  const urlToken = query.get('token');
  const [token, setToken] = React.useState(INIT_TOKEN);
  const [, checkToken] = useCheckToken(token);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: INIT_FORM,
    resolver: yupResolver(c.schema),
    reValidateMode: 'onSubmit',
  });

  const handleOnSubmit = (form) => {
    const args = {
      ...detail,
      ...form,
      token: !isNil(urlToken) && checkToken ? token?.token : null,
    };

    changePassword(args, () => {
      storage.remove('forgot-password-detail');
      history.push(`/login`);
    });
  };

  React.useEffect(() => {
    if (!isNil(urlToken)) {
      setToken({ token: urlToken });
    }
  }, [urlToken]);

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)}>
      <div className="border border-gray-200 rounded p-3 pb-1 mb-5">
        <Controller
          control={control}
          name="password"
          render={({ field: { onChange, value, name } }) => (
            <FormInput
              label="New Password"
              id={name}
              placeholder=""
              className="border-0 pr-12 pt-2 mt-1 ring-0 w-full outline-none text-gray-600"
              error={errors[name]}
              type="password"
              withShowPassword
              required
              name={name}
              value={value || ''}
              onChange={(e) => {
                onChange(e);
              }}
            />
          )}
        />
      </div>
      <div className="border border-gray-200 rounded p-3 pb-1 mb-5">
        <Controller
          control={control}
          name="password_confirmation"
          render={({ field: { onChange, value, name } }) => (
            <FormInput
              label="Confirm Password"
              id={name}
              placeholder=""
              className="border-0 pr-12 pt-2 mt-1 ring-0 w-full outline-none text-gray-600"
              error={errors[name]}
              type="password"
              withShowPassword
              required
              name={name}
              value={value || ''}
              onChange={(e) => {
                onChange(e);
              }}
            />
          )}
        />
      </div>

      <div className="space-y-3">
        <Button
          type="submit"
          isLoading={isApiLoading}
          className="btn primary md font-base text-sm"
          label="Next"
        />
      </div>
    </form>
  );
}
ChangePasswordForm.defaultProps = {};

ChangePasswordForm.propTypes = {};

export default ChangePasswordForm;
